var _style, _g, _path, _path2, _path3, _polygon, _polygon2, _path4, _path5, _polygon3, _polygon4, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMbMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98 21",
    style: {
      enableBackground: "new 0 0 98 21"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFCE00;}\n\t.st1{fill:#000D30;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,4.1c-1.3,0-2.4-1.1-2.4-2.5V1.5H2.6v0.1c0,1.3-1.1,2.5-2.4,2.5H0v3.7c0,4.1,2.1,8,5.5,10.3l2.3,1.5 L10,18c3.4-2.3,5.5-6.1,5.5-10.3V4.1H15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4.7,3.3 5.2,3.3 4.8,3.6 4.9,4.1 4.5,3.8 4.1,4.1 4.2,3.6 3.8,3.3 4.3,3.3 4.5,2.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.3,3.3 6.8,3.3 6.4,3.6 6.5,4.1 6.1,3.8 5.7,4.1 5.9,3.6 5.4,3.3 6,3.3 6.1,2.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.9,3.3 8.4,3.3 8,3.6 8.2,4.1 7.7,3.8 7.3,4.1 7.5,3.6 7.1,3.3 7.6,3.3 7.7,2.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "9.5,3.3 10,3.3 9.6,3.6 9.8,4.1 9.4,3.8 8.9,4.1 9.1,3.6 8.7,3.3 9.2,3.3 9.4,2.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.1,3.3 11.7,3.3 11.2,3.6 11.4,4.1 11,3.8 10.6,4.1 10.7,3.6 10.3,3.3 10.8,3.3 11,2.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.9,6L4.2,4.9H2.6v7.1c-0.1,1.2,0.5,1.6,0.5,1.6l1.1,0.7v-7L5,8.5l0.8-1.1v9.1l1.6,1V4.9H5.8L4.9,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,9.3l0.5-0.6V4.9H8.2v12.6l3.8-3c0.9-0.8,0.9-2.2,0.9-2.2V10L12.4,9.3z M11.3,12.2l-1.5,1v-2.8h1.5V12.2z  M11.3,8.5H9.8V6.9h1.5V8.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.4,12.6c0-1.2,0-3.2,0-4.4h-0.1c-0.2,2.1-0.5,5.8-0.6,6.7h-1.6c-0.1-1.5-0.4-5.1-0.6-6.8h-0.1 c0,1.1,0.1,2.9,0.1,4.4V15h-1.9V6h2.8c0.1,1,0.3,3.1,0.4,4.2H22C22.2,9,22.3,7.9,22.5,6h2.9V15h-2V12.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,13.1L28.9,15h-2.1L27.8,6h3.3l1.1,8.9H30l-0.1-1.9H29z M29.7,11.3c-0.1-0.8-0.2-2.9-0.3-3.5h-0.1 c0,0.5-0.2,2.6-0.2,3.5H29.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.5,12.1v0.6c0,0.6,0.1,0.8,0.4,0.8c0.3,0,0.3-0.2,0.3-0.6c0-0.7-0.1-0.9-1-1.7c-1.1-1-1.6-1.5-1.6-2.8 c0-1.4,0.6-2.5,2.3-2.5c1.9,0,2.3,1.2,2.3,2.4v0.5h-1.9V8.2c0-0.5-0.1-0.7-0.3-0.7c-0.2,0-0.3,0.2-0.3,0.6c0,0.5,0.1,0.7,0.8,1.3 c1.3,1.1,1.9,1.6,1.9,3.1c0,1.6-0.5,2.7-2.4,2.7c-1.8,0-2.4-1-2.4-2.5v-0.5H35.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40.8,7.8 39.6,7.8 39.6,6 44,6 44,7.8 42.9,7.8 42.9,15 40.8,15 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.3,11.1 47.5,11.1 47.5,13.2 49.6,13.2 49.4,15 45.4,15 45.4,6 49.3,6 49.3,7.8 47.5,7.8 47.5,9.4  49.3,9.4 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53,11.2V15h-2.1V6h2.6c1.7,0,2.3,0.8,2.3,2.3v0.3c0,1.1-0.4,1.6-0.9,1.8c0.6,0.3,0.8,0.8,0.8,2.1v0 c0,1,0,2.1,0,2.4h-2c-0.1-0.2-0.1-1-0.1-2.7v0c0-0.9-0.1-1-0.6-1H53z M53,9.6h0.2c0.4,0,0.6-0.1,0.6-0.8V8.3c0-0.5-0.1-0.7-0.6-0.7 H53V9.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.2,6h2.5c1.4,0,2.3,0.6,2.3,2v0.4c0,1.1-0.4,1.5-1,1.7c0.5,0.2,1.1,0.6,1.1,1.7v0.7c0,1.7-0.7,2.4-2.4,2.4 h-2.5V6z M59.5,9.4c0.3,0,0.5-0.2,0.5-0.6V8.2c0-0.4-0.1-0.7-0.5-0.7h-0.2v1.9H59.5z M59.3,13.4h0.2c0.4,0,0.5-0.2,0.5-0.7v-1 c0-0.5-0.1-0.7-0.6-0.7h-0.2V13.4z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "67.4,11.1 65.6,11.1 65.6,13.2 67.7,13.2 67.5,15 63.5,15 63.5,6 67.5,6 67.5,7.8 65.6,7.8 65.6,9.4  67.4,9.4 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "70.2,7.8 69.1,7.8 69.1,6 73.5,6 73.5,7.8 72.3,7.8 72.3,15 70.2,15 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.8,12.1v0.6c0,0.6,0.1,0.8,0.4,0.8c0.3,0,0.3-0.2,0.3-0.6c0-0.7-0.1-0.9-1-1.7c-1.1-1-1.6-1.5-1.6-2.8 c0-1.4,0.6-2.5,2.3-2.5c1.9,0,2.3,1.2,2.3,2.4v0.5h-1.9V8.2c0-0.5-0.1-0.7-0.3-0.7c-0.2,0-0.3,0.2-0.3,0.6c0,0.5,0.1,0.7,0.8,1.3 c1.3,1.1,1.9,1.6,1.9,3.1c0,1.6-0.5,2.7-2.4,2.7c-1.8,0-2.4-1-2.4-2.5v-0.5H76.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,8.7V8.2c0-1.1,0.4-2.2,2.2-2.2c1.5,0,2.3,0.7,2.3,2.1v0.4c0,1-0.5,1.5-1,1.7v0c0.5,0.2,1.1,0.6,1.1,1.8 v0.6c0,1.6-0.7,2.4-2.4,2.4c-1.8,0-2.3-1.1-2.3-2.3v-0.3h1.9v0.4c0,0.4,0.1,0.7,0.4,0.7c0.3,0,0.4-0.3,0.4-0.7v-0.8 c0-0.7-0.2-0.9-0.8-0.9h-0.6V9.4h0.7c0.5,0,0.7-0.1,0.7-0.8V8.1c0-0.4-0.1-0.6-0.3-0.6c-0.3,0-0.4,0.3-0.4,0.6v0.5H81.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.8,8.4V8.2c0-0.4-0.1-0.6-0.4-0.6c-0.3,0-0.4,0.3-0.4,0.8v1.1C89.4,9.1,89.9,9,90.3,9c1.2,0,1.6,0.9,1.6,2.1 v1.5c0,1.5-0.7,2.5-2.4,2.5c-1.7,0-2.4-0.9-2.4-2.6V8.8c0-1.7,0.6-2.8,2.4-2.8c2.1,0,2.3,1.4,2.3,2.3v0.1H89.8z M89.8,12.7v-1.5 c0-0.5-0.1-0.6-0.4-0.6c-0.2,0-0.4,0.1-0.4,0.7v1.4c0,0.4,0.1,0.7,0.4,0.7C89.7,13.4,89.8,13.2,89.8,12.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.6,7.9h-2.1c0,0.4-0.1,1-0.1,1.4c0.2-0.3,0.7-0.4,1.1-0.4c1.1,0,1.5,0.8,1.5,2.1v1.2c0,1.4-0.4,2.7-2.4,2.7 c-2.1,0-2.4-1.3-2.4-2.4v-0.3h1.9v0.5c0,0.4,0.1,0.6,0.4,0.6c0.3,0,0.4-0.2,0.4-0.7v-1.4c0-0.5-0.1-0.7-0.3-0.7 c-0.2,0-0.4,0.1-0.4,0.8l-1.9-0.1c0.1-1.3,0.3-3.4,0.4-5h4.1L97.6,7.9z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMbMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mb_mobile.c366b21250e8fca218480ddd9dc0cdb9.svg";